import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MyKnowledgeService, KnowledgeMenuItem } from '../../services/my-knowledge.service';
import { map } from 'rxjs/operators';
import { ApiConfigService } from '../../services/api-config.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-designer-cards',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './designer-cards.component.html',
  styleUrls: ['./designer-cards.component.css']
})
export class DesignerCardsComponent implements OnInit {
  cards$: Observable<any[]>;
  baseUrl: string;

  constructor(
    private myKnowledgeService: MyKnowledgeService,
    private router: Router,
    private apiConfigService: ApiConfigService
  ) {
    this.baseUrl = this.apiConfigService.getApiUrl('');
    this.cards$ = this.myKnowledgeService.getMenuItems().pipe(
      map(items => items.filter(item => item.parent_term_id === '' && item.name !== 'Coronavirus and you')),
      map(items => items.map(item => ({
        ...item,
        image: this.baseUrl + item.field_icon_image,
        title: item.name,
        subtitle: item.description__value_export
      })))
    );
  }

  ngOnInit(): void {}

  goToDetails(item: KnowledgeMenuItem): void {
    if (item.name === 'True Stories') {
      this.router.navigate(['/my-knowledge'], { state: { thematicAreaId: '312' } });
    } else {
      this.router.navigate(['/my-knowledge'], { state: { item, fromDesignerCard: true } });
    }
  }
}
